import { createFileRoute } from '@tanstack/react-router'

import { MoreScreen } from '@/features/more/more-screen'

/** The phone's More: the screens the tab bar has no room for, the account, the theme, the status. */
export const Route = createFileRoute('/_app/_org/more')({
  component: MoreScreen,
})
